import LyTable from './src/index.vue'

LyTable.install = function (Vue) {
    Vue.component(LyTable.name, LyTable)
}

export default LyTable



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/table/index.js
// module id = null
// module chunks = 